import view from '../../view';
import wrapperMap from '../helpers/wrapper-map';

const isWrappedBy = (wrapperId) => {
  const wrapper = wrapperMap.getWrapperById(wrapperId);
  if (!wrapper) throw new Error('wrapper with specified id is not exist');

  const liveDocument = view.accessors.getLiveDocument();
  return wrapper.isAppliedToSelection(liveDocument.defaultView);
};

export default isWrappedBy;
